/* feela. 整体エルゴクッション SEAT 専用LP (feela-seat-v2) モーション基盤 v2
   このファイルはこのLP専用。商品選択・モーダル・固定CTAのロジック（feela-seat-v2.js）とは分離する。

   設計:
   - 初期化に成功した場合だけ .feela-seat-v2 ルートへ data-fsv-motion-ready を付ける。
     CSS側の「開始状態（非表示）」はすべて [data-fsv-motion-ready] 配下に閉じているため、
     JS無効・初期化失敗・prefers-reduced-motion では全コンテンツが最初から通常表示になる。
   - IntersectionObserver は3個まで:
       1) revealObserver … LP全体の登場演出（一度表示したら unobserve）
       2) focusObserver  … リスト（data-fsv-ergo-list）が画面内にあるかどうかだけを検知する。
                           「画面内にある間、中央に最も近い項目1つだけを is-active にする」計算自体は
                           このobserverではなくスクロール時のrequestAnimationFrameで行う（詳細は§2）
       3) ambientObserver… 継続アニメーションを持つセクションの出入りを監視し、画面外では停止
   - 連続的なスクロール位置計算（人間工学の01/02/03のうちどれを強調するか）だけは
     requestAnimationFrameで1フレームにまとめる。対象リストが画面内にある間だけ動き、
     画面外・モーダル／ライトボックス表示中は計算しない。それ以外の登場演出はCSSアニメ＋observer駆動のまま。
   - モーダル／ライトボックス表示中は feela-seat-v2.js が html に fsv-overlay-open を付けるので、
     CSS側で継続アニメーションを animation-play-state: paused にする。 */
(function () {
  'use strict';

  if (window.__fsvMotionV2Initialized) return;
  window.__fsvMotionV2Initialized = true;

  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* reduced-motion または IntersectionObserver 非対応環境では
     ready属性を付けず、静的表示のまま終了する */
  if (prefersReducedMotion || !('IntersectionObserver' in window)) return;

  var revealObserver = null;
  var focusObserver = null;
  var ambientObserver = null;

  function markReady() {
    document.querySelectorAll('.feela-seat-v2').forEach(function (root) {
      root.setAttribute('data-fsv-motion-ready', 'true');
    });
  }

  function unmarkReady() {
    document.querySelectorAll('.feela-seat-v2[data-fsv-motion-ready]').forEach(function (root) {
      root.removeAttribute('data-fsv-motion-ready');
    });
  }

  /* ---- 1) 登場演出（共通1個・一度表示したら解除） ---- */
  function createRevealObserver() {
    revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0, rootMargin: '0px 0px -12% 0px' }
    );
  }

  function observeReveals() {
    document.querySelectorAll('.fsv-reveal:not(.is-visible)').forEach(function (el) {
      if (el.dataset.fsvRevealObserved === 'true') return;
      el.dataset.fsvRevealObserved = 'true';
      revealObserver.observe(el);
    });
  }

  /* アンカージャンプ等で交差が観測されず表示漏れになるケースの保険。
     スクロールが止まった時に、画面より上を通り過ぎた未表示要素だけ表示する。 */
  var scrollSettleTimer = null;
  function onScrollSettle() {
    if (scrollSettleTimer) clearTimeout(scrollSettleTimer);
    scrollSettleTimer = setTimeout(function () {
      document.querySelectorAll('.fsv-reveal:not(.is-visible)').forEach(function (el) {
        if (el.getBoundingClientRect().bottom < 0) {
          el.classList.add('is-visible');
          revealObserver.unobserve(el);
        }
      });
    }, 150);
  }

  /* ---- 2) 順次強調（sticky演出と組で使う共通機構） ----
     [data-fsv-ergo-list] を持つリストが画面内にある間、画面中央に最も近い
     1項目だけを必ず is-active にする（01→02→03、上方向は03→02→01）。
     - observerは「リストが画面内にあるか」の検知だけに使う（1インスタンス）
     - 選択の計算はスクロール時に requestAnimationFrame で1フレームにまとめ、
       リストが画面外・モーダル／ライトボックス表示中は行わない
     - 切り替えは同期的に「他を外してから1つ付ける」ため、複数同時アクティブや
       全項目非アクティブの瞬間は作らない。画面外に出たら全て消灯する */
  var visibleFocusLists = [];
  var focusRafId = null;

  function createFocusObserver() {
    focusObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var idx = visibleFocusLists.indexOf(entry.target);
          if (entry.isIntersecting) {
            if (idx === -1) visibleFocusLists.push(entry.target);
          } else {
            if (idx !== -1) visibleFocusLists.splice(idx, 1);
            clearFocusList(entry.target);
          }
        });
        updateFocus();
      },
      { threshold: 0 }
    );
  }

  function setRegions(list, activeNumber) {
    var section = list.closest('.feela-seat-v2__section');
    if (!section) return;
    section.querySelectorAll('[data-fsv-ergo-region]').forEach(function (region) {
      region.classList.toggle('is-active', region.dataset.fsvErgoRegion === activeNumber);
    });
  }

  function clearFocusList(list) {
    list.querySelectorAll('[data-fsv-ergo-item]').forEach(function (el) {
      el.classList.remove('is-active');
    });
    setRegions(list, null);
  }

  function updateFocus() {
    if (document.documentElement.classList.contains('fsv-overlay-open')) return;
    var center = window.innerHeight / 2;
    visibleFocusLists.forEach(function (list) {
      if (!list.isConnected) return;
      var items = Array.from(list.querySelectorAll('[data-fsv-ergo-item]'));
      if (!items.length) return;
      var best = null;
      var bestIndex = -1;
      var bestDist = Infinity;
      items.forEach(function (el, i) {
        var rect = el.getBoundingClientRect();
        var dist = Math.abs((rect.top + rect.bottom) / 2 - center);
        if (dist < bestDist) {
          bestDist = dist;
          best = el;
          bestIndex = i;
        }
      });
      items.forEach(function (el) {
        if (el !== best) el.classList.remove('is-active');
      });
      best.classList.add('is-active');
      setRegions(list, String(bestIndex + 1));
    });
  }

  function onFocusScroll() {
    if (!visibleFocusLists.length) return;
    if (focusRafId !== null) return;
    focusRafId = requestAnimationFrame(function () {
      focusRafId = null;
      updateFocus();
    });
  }

  function observeFocusItems() {
    document.querySelectorAll('[data-fsv-ergo-list]').forEach(function (el) {
      if (el.dataset.fsvErgoObserved === 'true') return;
      el.dataset.fsvErgoObserved = 'true';
      focusObserver.observe(el);
    });
  }

  /* ---- 3) 継続アニメーションの画面外停止 ---- */
  function createAmbientObserver() {
    ambientObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          entry.target.setAttribute('data-fsv-inview', entry.isIntersecting ? 'true' : 'false');
        });
      },
      { threshold: 0, rootMargin: '10% 0px 10% 0px' }
    );
  }

  function observeAmbientScopes() {
    document.querySelectorAll('[data-fsv-ambient-scope]').forEach(function (el) {
      if (el.dataset.fsvAmbientObserved === 'true') return;
      el.dataset.fsvAmbientObserved = 'true';
      ambientObserver.observe(el);
    });
  }

  /* ---- 購入エリア連携（既存の選択処理には触れず、外から演出だけ足す） ---- */

  /* モーダルで硬さを選んで購入エリアへ移動した時、選択済みの硬さを一度だけ弱く強調 */
  function flashSelectedHardness() {
    var purchase = document.querySelector('feela-seat-purchase');
    if (!purchase) return;
    var checked = Array.from(purchase.querySelectorAll('input[type="radio"]')).find(function (input) {
      return input.dataset.optionName === '硬さ' && input.checked;
    });
    if (!checked) return;
    var option = checked.closest('.feela-seat-v2-purchase__option');
    if (!option) return;
    option.classList.remove('fsv-hardness-flash');
    void option.offsetWidth; /* 連続選択でもアニメを再生し直すためのリフロー */
    option.classList.add('fsv-hardness-flash');
    option.addEventListener(
      'animationend',
      function () {
        option.classList.remove('fsv-hardness-flash');
      },
      { once: true }
    );
  }

  document.addEventListener('click', function (event) {
    if (!event.target.closest || !event.target.closest('[data-fsv-select-hardness]')) return;
    /* モーダルが閉じてスクロールが始まってから光らせる（closeModalの220msより後） */
    setTimeout(flashSelectedHardness, 500);
  });

  /* バリエーション切り替え時、商品画像に短いフェードを足す（src差し替え自体は既存処理のまま） */
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || target.type !== 'radio') return;
    var purchase = target.closest && target.closest('feela-seat-purchase');
    if (!purchase) return;
    var img = purchase.querySelector('[data-fsv-media]');
    if (!img) return;
    img.classList.remove('fsv-media-swap');
    void img.offsetWidth;
    img.classList.add('fsv-media-swap');
    img.addEventListener(
      'animationend',
      function () {
        img.classList.remove('fsv-media-swap');
      },
      { once: true }
    );
  });

  /* ---- 初期化 ---- */
  function scan() {
    observeReveals();
    observeFocusItems();
    observeAmbientScopes();
  }

  try {
    createRevealObserver();
    createFocusObserver();
    createAmbientObserver();
    scan();
    markReady();
    window.addEventListener('scroll', onScrollSettle, { passive: true });
    window.addEventListener('scroll', onFocusScroll, { passive: true });
    window.addEventListener('resize', onFocusScroll, { passive: true });
    /* モーダル／ライトボックスを閉じた直後（overlay-openが外れた瞬間）に、
       止まっていた選択を現在位置で計算し直す。閉じている間は毎フレーム計算しない。 */
    new MutationObserver(function () {
      if (!document.documentElement.classList.contains('fsv-overlay-open')) {
        updateFocus();
      }
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  } catch (error) {
    /* 初期化に失敗した場合はコンテンツが消えたままにならないよう静的表示へ戻す */
    unmarkReady();
    return;
  }

  /* テーマエディタでセクションが個別に再読み込みされた場合、
     新しく増えた要素だけを追加で拾う（observer・リスナーは使い回す） */
  document.addEventListener('shopify:section:load', function () {
    try {
      scan();
      markReady();
    } catch (error) {
      unmarkReady();
    }
  });
})();
